import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { Field, reduxForm } from 'redux-form';
import Input from '../input';
import Button, { ButtonGroup } from '../button';
import Warning from '../warning';

const validate = (fields) => {
  const error = {};
  if (!fields.usercode)
    error.usercode = <Translate value='formErrors.requiredField' />;
  return error;
};


class VerifyOtpForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field name="usercode"
          type="text"
          label={I18n.t('general.enable_otp_text.page_2_info_alt')}
          component={Input}
        />
        <ButtonGroup>
          <Button onClick={this.props.cancel}
            type='button'
            text={I18n.t('general.cancel')}
            secondary
          />
          <Button type='submit'
            text={I18n.t('general.next')}
            fetching={this.props.submitting}
            disabled={this.props.pristine || !this.props.valid}
          />
        </ButtonGroup>
        {this.props.error &&
          <Warning text={this.props.error} color="red" formWarning={true} />
        }
      </form>
    )
  }
}

VerifyOtpForm = reduxForm({ form: 'VerifyOtpForm', validate })(
  VerifyOtpForm
)

VerifyOtpForm.propTypes = {
  next_step: PropTypes.func,
  cancel: PropTypes.func,
  locale: PropTypes.string
};

export default connect((state) => {
  return {
    locale: state.i18n.locale
  };
})(VerifyOtpForm);
